import React, { useEffect } from "react";
import axios from "axios";

function LeaderboardShortLink(props) {
  const shortCode = props.match?.params?.shortCode;

  useEffect(() => {
    if (!shortCode) {
      window.location.replace("/");
      return;
    }

    const loadLeaderboard = async () => {
      try {
        const response = await axios.get(
          process.env.REACT_APP_API_URL +
            "circles/leaderboard-link/short/" +
            shortCode,
        );

        if (response.data?.success && response.data?.url) {
          window.location.replace(response.data.url);
          return;
        }

        window.location.replace("/");
      } catch (error) {
        console.log("Leaderboard short link error:", error);
        window.location.replace("/");
      }
    };

    loadLeaderboard();
  }, [shortCode]);

  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#1b2230",
        color: "#ffffff",
        fontFamily: "Arial, sans-serif",
        fontSize: "22px",
        fontWeight: "700",
      }}
    >
      Loading leaderboard...
    </div>
  );
}

export default LeaderboardShortLink;
